export const MAP_MIN_ZOOM=1;
export const MAP_MAX_ZOOM=20;
export const WEB_MAP_MAX_ZOOM=18;
const EPSILON=.001;

export function zoomAvailability(zoom,min=MAP_MIN_ZOOM,max=MAP_MAX_ZOOM){
 return {in:Number.isFinite(zoom)&&zoom<max-EPSILON,out:Number.isFinite(zoom)&&zoom>min+EPSILON};
}
export function nextZoom(zoom,direction,min=MAP_MIN_ZOOM,max=MAP_MAX_ZOOM){
 if(!Number.isFinite(zoom))return null;
 if(!zoomAvailability(zoom,min,max)[direction])return zoom;
 return Math.max(min,Math.min(max,zoom+(direction==='in'?1:-1)));
}
